import * as React from "react";
import {
  Button as RootButton,
  buttonVariants as rootButtonVariants,
} from "../../../components/ui/button";
import type { VariantProps } from "class-variance-authority";

type RootButtonProps = React.ComponentProps<typeof RootButton> &
  VariantProps<typeof rootButtonVariants>;

type V32Variant =
  | "default"
  | "secondary"
  | "outline"
  | "destructive"
  | "ghost"
  | "link"
  | "primary"
  | "warning";

export interface ButtonProps
  extends Omit<RootButtonProps, "variant"> {
  variant?: V32Variant | null;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = "default", ...props }, ref) => {
    const mapped: Exclude<V32Variant, "primary" | "warning"> =
      variant === "primary"
        ? "default"
        : variant === "warning"
          ? "destructive"
          : (variant as any);
    return <RootButton ref={ref} variant={mapped} {...props} />;
  },
);
Button.displayName = "Button";

export const buttonVariants = rootButtonVariants;
